const GuyWithLaptopIcon = (props) => {
  return (
    <svg
      width="360"
      height="240"
      viewBox="0 0 360 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4095 169.364C36.5362 218.861 306.251 251.499 338.583 191.353C370.914 131.207 303.303 52.7034 202.39 55.0016C101.476 57.2992 0.283422 119.867 18.4095 169.364Z"
        fill="#F2F2F2"
      />
      <path
        d="M225.593 98.3801C226.381 93.8261 230.332 90.5 234.954 90.5H287.121C293.015 90.5 297.487 95.8119 296.482 101.62L285.407 165.62C284.619 170.174 280.668 173.5 276.046 173.5H223.879C217.985 173.5 213.513 168.188 214.518 162.38L225.593 98.3801Z"
        stroke="#ECECEC"
      />
      <path
        d="M233.835 109.444C233.95 109.004 234.347 108.697 234.802 108.697H250.056C250.711 108.697 251.189 109.316 251.024 109.949L250.149 113.297C250.034 113.738 249.637 114.045 249.182 114.045H233.928C233.273 114.045 232.795 113.426 232.96 112.792L233.835 109.444Z"
        fill="#ECECEC"
      />
      <rect
        x="231.742"
        y="117.61"
        width="25.8481"
        height="1.78263"
        rx="0.891315"
        fill="#ECECEC"
      />
      <rect
        x="244.22"
        y="137.219"
        width="35.6526"
        height="1.78263"
        rx="0.891315"
        fill="#ECECEC"
      />
      <rect
        x="225.503"
        y="141.675"
        width="52.5876"
        height="1.78263"
        rx="0.891315"
        fill="#ECECEC"
      />
      <rect
        x="228.177"
        y="127.414"
        width="52.5876"
        height="1.78263"
        rx="0.891315"
        fill="#ECECEC"
      />
      <rect
        x="226.394"
        y="147.023"
        width="50.805"
        height="1.78263"
        rx="0.891315"
        fill="#ECECEC"
      />
      <rect
        x="229.959"
        y="122.958"
        width="51.6963"
        height="1.78263"
        rx="0.891315"
        fill="#ECECEC"
      />
      <path
        d="M154.662 156.731C154.662 156.731 112.893 136.782 104.165 124.314C95.4375 111.845 114.14 108.729 114.14 108.729C114.14 108.729 127.231 106.858 132.842 106.235C138.453 105.611 150.298 104.365 150.298 104.365L152.168 113.716C152.168 113.716 129.725 120.574 132.842 121.82C135.959 123.067 160.896 133.041 160.896 133.041L154.662 156.731Z"
        fill="#BAD1DE"
      />
      <path
        d="M178.227 126.268C178.882 126.912 208.203 134.446 208.203 134.446L201.936 151.225L169.876 148.787L178.227 126.268Z"
        fill="#BAD1DE"
      />
      <path
        d="M171.517 128.051C171.517 128.051 152.359 135.107 149.376 141.499C150.404 150.527 153.555 159.215 158.745 166.645C165.114 175.757 172.983 191.416 171.534 211.835H226.921C226.921 211.835 223.938 154.387 207.543 132.336L171.517 128.051Z"
        fill="#BAD1DE"
      />
      <path
        d="M165.42 138.807L159.666 145.877L155.615 134.852C155.615 134.852 156.676 129.9 159.987 130.845L165.42 138.807Z"
        fill="white"
      />
      <path
        d="M175.066 139.79C180.037 137.337 184.548 134.345 182.092 129.301L172.429 111.466L154.438 120.345L161.624 135.102C164.081 140.146 170.095 142.242 175.066 139.79Z"
        fill="#FFEDE1"
      />
      <path
        d="M175.145 116.574C175.145 116.574 176.424 129.716 166.927 132.994C158.608 135.859 156.188 123.206 156.188 123.206L175.145 116.574Z"
        fill="#F4DED0"
      />
      <path
        d="M162.905 128.464L164.636 128.055C173.324 126.012 178.736 117.226 176.719 108.441L174.434 98.4121C172.417 89.6093 163.745 84.1268 155.074 86.17L153.343 86.5786C144.654 88.6218 139.243 97.4075 141.26 106.193L143.545 116.222C145.562 125.025 154.234 130.507 162.905 128.464Z"
        fill="#FFEDE1"
      />
      <path
        d="M171.274 112.617C170.871 113.315 170.484 114.37 170.35 115.971C170.198 117.997 169.19 119.921 167.51 121.045C162.686 124.28 159.006 116.09 151.881 117.537C151.881 117.537 149.091 117.963 148.536 121.113C147.982 124.246 144.1 118.763 143.243 115.017C142.385 111.272 141.949 133.559 159.493 131.669C159.493 131.669 168.35 131.38 174.316 122.237C174.971 121.232 175.358 120.057 175.391 118.848C175.442 117.061 175.19 114.353 173.509 112.412C172.921 111.697 171.744 111.799 171.274 112.617Z"
        fill="#102F56"
      />
      <path
        d="M171.291 107.557C171.291 107.557 163.712 105.02 164.989 93.7992C164.989 93.7992 146.167 111.847 132.219 98.6006C132.219 98.6006 138.454 96.915 141.025 92.5903C145.713 84.707 159.191 73.8441 169.98 86.4097C169.98 86.4097 183.105 84.3495 179.341 104.832L171.291 107.557Z"
        fill="#102F56"
      />
      <path
        d="M171.291 107.56C172.014 110.693 175.106 112.651 178.198 111.936C181.307 111.204 183.223 108.071 182.517 104.938C181.794 101.805 178.702 99.8472 175.61 100.562C172.501 101.294 170.568 104.427 171.291 107.56Z"
        fill="#FFEDE1"
      />
      <path
        d="M165.481 138.747L173.442 138.894L167.871 150.334L161.855 139.368L165.481 138.747Z"
        fill="#102F56"
      />
      <path
        d="M180.482 126.879L169.876 139.003L176.782 146.769L189.485 129.668C189.485 129.668 186.228 124.541 180.482 126.879Z"
        fill="white"
      />
      <path
        d="M167.3 145.715C167.3 145.715 160.238 166.734 163.295 196.062L171.289 202.916L179.976 193.78L168.374 144.328L167.3 145.715Z"
        fill="#102F56"
      />
      <path
        d="M186.128 190.395L169.323 195.996L168.214 205.991L190.498 199.249L186.128 190.395Z"
        fill="#FFEDE1"
      />
      <path
        d="M171.827 202.608C171.827 208.448 168.376 207.227 159.649 207.85C153.885 207.85 147.181 209.344 147.181 203.487C147.181 197.646 155.593 192.018 161.374 192.018C167.138 192.018 171.827 196.751 171.827 202.608Z"
        fill="#FFEDE1"
      />
      <path
        d="M83.7812 159.231H134.281C135.945 159.231 137.374 160.406 137.726 162.057L147.238 207.246C147.709 209.459 146.028 211.553 143.793 211.553H92.4528C90.7723 211.553 89.327 210.345 89.0077 208.676L80.3361 163.487C79.8992 161.274 81.5629 159.231 83.7812 159.231Z"
        fill="#B2B2B2"
      />
      <path
        d="M81.9508 159.502H132.434C134.098 159.502 135.527 160.677 135.879 162.328L145.391 207.516C145.862 209.73 144.198 211.824 141.946 211.824H90.6224C88.9419 211.824 87.4966 210.615 87.1773 208.947L78.5057 163.758C78.0688 161.545 79.7325 159.502 81.9508 159.502Z"
        fill="#D1D1D1"
      />
      <path
        d="M145.861 207.69H180.362C181.421 207.69 182.261 208.558 182.261 209.614C182.261 210.686 181.404 211.538 180.362 211.538H145.188L145.861 207.69Z"
        fill="#B2B2B2"
      />
      <path
        d="M113.209 184.477C113.209 187.559 110.756 190.045 107.714 190.045C104.672 190.045 102.218 187.542 102.218 184.477C102.218 181.395 104.689 178.909 107.714 178.909C110.756 178.909 113.209 181.395 113.209 184.477Z"
        fill="white"
      />
      <path
        d="M198.734 148.978L218.155 166.116L177.728 190.395L185.449 202.742C185.449 202.742 210.768 196.005 233.211 179.797C234.707 178.278 238.888 176.472 240.692 170.446C242.496 164.419 242.743 157.037 218.823 136.911C207.833 127.664 201.374 131.251 196.869 134.761C193.4 139.618 195.994 145.017 198.734 148.978Z"
        fill="#BAD1DE"
      />
      <path
        d="M178.789 190.443L219.79 167.982L199.596 146.769"
        stroke="#DDE8EE"
        strokeWidth="0.7599"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M185.029 201.139C185.029 201.139 211.957 193.332 224.247 185.987"
        stroke="#DDE8EE"
        strokeWidth="0.7599"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M202.639 81.9133C218.563 86.4399 235.145 77.1889 239.675 61.2507C244.206 45.3125 234.97 28.7226 219.046 24.196C203.122 19.6695 186.54 28.9205 182.01 44.8587C177.479 60.7969 186.715 77.3868 202.639 81.9133ZM207.004 45.6942C208.709 43.8778 211.139 43.1401 213.229 43.7343C215.797 44.4641 217.234 46.6582 216.65 48.7139C216.253 50.1089 214.914 51.4739 213.396 52.0738L212.092 52.6158C209.438 53.726 207.862 54.6668 207.163 57.1263L206.933 57.9339C206.766 58.5213 207.039 58.9559 207.626 59.1227L208.91 59.4876C209.46 59.644 209.91 59.4546 210.124 58.841L210.338 58.2273C210.808 56.8532 212.138 56.0806 213.567 55.6537L215.044 55.2006C217.866 54.3365 219.849 52.5197 220.621 49.8032C221.811 45.6183 219.093 41.513 214.252 40.1368C210.731 39.136 206.835 40.2901 204.235 43.1615C203.833 43.6024 203.828 44.0375 204.268 44.4404L205.825 45.7956C206.203 46.141 206.564 46.1247 207.004 45.6942ZM207.509 61.9063C206.225 61.5414 204.869 62.2669 204.494 63.5885C204.118 64.91 204.853 66.2298 206.173 66.6051C207.567 67.0013 208.886 66.2653 209.262 64.9438C209.637 63.6223 208.866 62.2921 207.509 61.9063Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.0169 96.435C104.006 90.6453 105.796 79.4708 100.013 71.4759C94.2303 63.4811 83.0658 61.6935 75.0763 67.4831C67.0867 73.2728 65.2977 84.4474 71.0802 92.4422C76.8628 100.437 88.0273 102.225 96.0169 96.435ZM80.6884 81.0445C80.4679 79.5764 81.019 78.1667 82.0679 77.4066C83.3561 76.4731 84.9123 76.6084 85.6582 77.6396C86.1643 78.3393 86.3087 79.4696 86.0293 80.4018L85.802 81.212C85.3423 82.8643 85.2012 83.9489 86.0935 85.1826L86.3866 85.5878C86.5997 85.8824 86.9036 85.9148 87.198 85.7014L87.8421 85.2347C88.1181 85.0346 88.1956 84.754 87.9876 84.4276L87.7795 84.1012C87.3102 83.3748 87.4392 82.4674 87.7668 81.6406L88.0995 80.7821C88.7362 79.1419 88.618 77.5436 87.6323 76.1809C86.114 74.0817 83.1918 73.8417 80.7627 75.602C78.996 76.8822 78.099 79.132 78.4829 81.4078C78.5406 81.759 78.7423 81.9215 79.0932 81.8637L80.3012 81.6338C80.602 81.5843 80.7276 81.409 80.6884 81.0445ZM88.4565 86.7821C87.8124 87.2489 87.6517 88.1512 88.1311 88.8141C88.6106 89.477 89.4988 89.6193 90.1613 89.1392C90.8606 88.6324 91.0029 87.7434 90.5234 87.0805C90.044 86.4176 89.1374 86.2887 88.4565 86.7821Z"
        fill="#C5CFD6"
      />
      <circle cx="273.5" cy="108.5" r="4.5" fill="#ECECEC" />
      <path
        d="M264 120C264.659 116.52 267.7 114 271.242 114H274.893C278.065 114 280.454 116.884 279.864 120H264Z"
        fill="#ECECEC"
      />
    </svg>
  );
};

export default GuyWithLaptopIcon;
